import { html } from 'lit';
import { state, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzMultiSelectItem, MultiSelectEvents } from '../types';
import { FormFieldInput } from '../../gzForm/formField/component/FormFieldInput';
import { areArraysEqual } from '@nirvana/shared/basic-types/object';

export class GzMultiSelectGroupWebComponent extends FormFieldInput<Array<string | number>> {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  @property({ type: Array, attribute: true, reflect: true })
  options: GzMultiSelectItem[] = [];

  @state()
  selected: Array<string | number> = [];

  @property({ type: Boolean, reflect: true })
  disabled = false;

  private static updateSelectedOptions(array: Array<string | number>, value: string | number) {
    const index = array.indexOf(value);

    if (index === -1) {
      array.push(value);
    } else {
      array.splice(index, 1);
    }
    return array;
  }

  private static isItemSelected(array: Array<string | number>, value: string | number): boolean {
    return array.indexOf(value) !== -1;
  }

  public setEnabled(isEnabled: boolean): void {
    // TODO @dnemtuc as part of the form-field disable story
    this.disabled = !isEnabled;
  }

  public setFormValue(value: Array<string | number>) {
    this.selected = [...value];
    this.dispatchEvent(new CustomEvent(MultiSelectEvents.CHANGE, { bubbles: true }));
  }

  public getFormValue(): Array<string | number> {
    return this.selected;
  }

  render() {
    return html`
      <div class="multiselect-group">${this.options.map(option => this.renderMultiselectItem(option))}</div>
    `;
  }

  private renderMultiselectItem(option: GzMultiSelectItem) {
    const { label, value, disabled } = option;
    const isDisabled = disabled || this.disabled;
    const isSelected = GzMultiSelectGroupWebComponent.isItemSelected(this.selected, value);

    return html`
      <gz-multiselect-item
        @change="${this.itemChange}"
        label="${label}"
        .value="${value}"
        ?selected="${isSelected}"
        ?disabled="${isDisabled}"
        ?invalid="${this.invalid}"
      ></gz-multiselect-item>
    `;
  }

  private itemChange(e: CustomEvent) {
    const selected = GzMultiSelectGroupWebComponent.updateSelectedOptions(this.getFormValue(), e.detail.value);
    this.setFormValue(selected);
  }

  /**
   * Overrides FormFieldInput method for comparing two arrays
   * (this component uses array as form field value)
   */
  public areFormValuesEqual(value1: Array<string | number>, value2: Array<string | number>) {
    return areArraysEqual(value1, value2);
  }
}
